export const callStatusZh = {
    calling:'正在呼叫',
    callFailed:'呼叫失败',
    callEnded:'呼叫结束',
    confirmed:'通话中',
    accepted:'接听中',
    failed:'接失败,他挂或你拒',
    ended:'接听结束'
}

export const sipStatusZh = {
    loging:'登录中',
    registered:'已登录',
    unregistered:'未注册/已退出',
    registrationFailed:'登录失败'
}
